/**
 * Which mail a one-click unsubscribe link switched off. Mirrors the backend enum
 * (PascalCase on the wire).
 */
export enum UnsubscribeKind {
  Announcements = "Announcements",
  SessionReminders = "SessionReminders",
}
